import React from 'react';
import styled from 'styled-components';
import { bool } from 'prop-types';

export const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  background: #F5F5F5;
  height: 100vh;
  text-align: left;
  padding: 120px 0px;
  position: ${({ open }) => open ? 'fixed' : 'absolute'};
  width: 180px;
  top: 0;
  left: 0;
  transition: transform 0.3s ease-in-out;
    transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(-100%)'};

  z-index: 20;

  @media (max-width: 900px) {
    width: 180px;
  }

  a {
    font-size: 1rem;
    padding: 1rem 2rem;
    font-weight: bold;
    color: #242424;
    text-decoration: none;
    transition: color 0.3s linear;

    @media (max-width: ${({ theme }) => theme.mobile}) {
      font-size: 1.5rem;
      text-align: center;
    }

    :hover {
      color: #377879;
      background-color: #DBDBDB;
    }
  }
`;

export const Menu = ({open}) => {
    Menu.propTypes = {
        open: bool.isRequired,
    }
    return (
      <StyledMenu open={open}>
        <a href="/">
          Home
        </a>
        <a href="/about">
          About
        </a>
        <a href="/first100days">
          First 100 Days
          </a>
        <a href="/care">
          Caregiver Preparation
        </a>
        <a href="/prognosis">
          Prognosis
        </a>
        <a href="/profile">
          Profile
        </a>
      </StyledMenu>
    )
  }

//   export default Menu;